import Image from 'next/image';

import { StyledH2, StyledParagraph } from '@/components/SwapTokens/utils';

import { NETWORK_NAME_PER_CHAIN_ID, SUPPORTED_CHAIN_IDS } from '@/constants/chain';

import { ChainAvatar } from '@/ui/Avatars/ChainAvatar';

export function LowCapTokensSection() {
  return (
    <div className="desktop:flex gap-5 max-w-[1240px] mx-auto">
      <div
        className="border border-token-gray-300 overflow-hidden rounded-lg tablet:pt-15 tablet:px-15 w-full mx-auto mb-5 flex justify-center max-w-[1240px] flex-col items-center pb-[52px] desktop:justify-start pt-12 px-[34px] desktop:flex-[55%]"
        style={{
          background:
            'url(/images/swap-tokens/low-cap-background.svg) no-repeat left top, var(--token-color-gray-100)',
        }}
      >
        <StyledH2 className="text-center max-w-[336px]">Low cap and airdropped tokens?</StyledH2>
        <StyledParagraph className="text-center">
          Find new coins before anyone else.
        </StyledParagraph>
        <Image
          className="max-w-full h-auto mt-[70px]"
          src="/images/swap-tokens/low-cap.png"
          alt=""
          width={493}
          height={166}
        />
      </div>
      <div className="border border-token-gray-300 overflow-hidden rounded-lg tablet:pt-15 px-11 tablet:px-15 w-full mx-auto mb-5 bg-token-gray-100 flex justify-center max-w-[1240px] flex-col items-center pb-[34px] tablet:pb-[84px] desktop:pb-[96px] desktop:justify-between pt-12 desktop:flex-[45%]">
        <StyledH2 className="text-center">Across {SUPPORTED_CHAIN_IDS.length} chains</StyledH2>
        <StyledParagraph className="text-center">
          Matcha is available on all your favorite chains.
        </StyledParagraph>
        <ul className="flex items-center justify-center p-0 pt-16 desktop:pt-[100px] desktop:mt-4 flex-wrap gap-3 max-w-[392px]">
          {SUPPORTED_CHAIN_IDS.map((chainId: number) => (
            <li className="p-3 relative" key={chainId}>
              <div className="absolute bg-token-gray-200 border border-token-alphalight-300 top-0 left-0 w-[68px] h-[68px] rounded-2xl opacity-70" />
              <ChainAvatar
                chainId={chainId}
                alt={`${NETWORK_NAME_PER_CHAIN_ID[chainId]} icon`}
                size={44}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
